module.exports = __webpack_public_path__ + "static/media/choithramsPriceRound.f0d65d82.png";